import React from 'react';
import { Container, Row, Col } from 'react-bootstrap';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import * as _ from 'lodash';
import * as moment from 'moment';
import { Link } from 'react-router-dom';
import cx from 'classnames';
import ReactApexChart from 'react-apexcharts';
import { BackStrip } from '../../../common/layout';
import * as absencesActions from '../../../store/portal';
import * as adminActions from '../../../store/admin';
import { deviceDetect } from 'react-device-detect';
import { config } from '../../../config/config';
import { utilService } from '../../../common/utils';
import LearningGoals from './LearningGoals';
import ParentStyle from '../../../styles/parent-dashboard.module.scss';
import StudentTable from './student-table.js';
import NotesPopup from './notes-popup';
import Chart from './Chart';
import { log } from 'async';

const boxPlotColors = {
  upper: '#CADB2A',
  // upper: '#C41425',
  lower: '#A7A9AC',
};

class ParentDashboard extends React.Component {
  constructor(props) {
    super(props);
    this.onChangeStudent = this.onChangeStudent.bind(this);
    this.onChangeAcademicReport = this.onChangeAcademicReport.bind(this);
    this.onClickonPlot = this.onClickonPlot.bind(this);
    this.onClickLearningBehaviourBox =
      this.onClickLearningBehaviourBox.bind(this);
    this.onChangeLearningType = this.onChangeLearningType.bind(this);
    this.handleNotes = this.handleNotes.bind(this);
    this.behaviourScales = [
      {
        text: 'Consistently',
        positionTop: 0,
      },
      {
        text: 'Usually',
        positionTop: 25,
      },
      {
        text: 'Sometimes',
        positionTop: 50,
      },
      {
        text: 'Rarely',
        positionTop: 75,
      },
    ];
    // this.loadPlotCourses = this.loadPlotCourses.bind(this);
    this.state = {
      file_id: '',
      is_dwd: false,
      isCarer: false,
      carerStudents: [],
      yearList: [],
      studentList: [],
      selectedStudent: '',
      getStudentsforTeacher: [],
      selectedStudentList: [
        {
          name: '',
          value: '',
        },
      ],
      selectedReport: '',
      selectedAcademicReportObj: {},
      academicReports: [],
      chartType: 'boxPlot',
      downloading_pdf: false,
      clickedCourseId: '',
      learningType: 'LEARNING_BEHAVIOUR_ANNUAL',
      showLearningDetails: false,
      showGoalReflectionsDetails: false,
      learningBehaviours: {
        this_year: null,
        trending: '',
      },
      goalsReflections: {
        formFields: {
          semester: 'Semester 1',
          selected_year: moment().format('YYYY'),
        },
        semesters: ['Semester 1', 'Semester 2'],
        years: [
          moment().format('YYYY'),
          moment().subtract(1, 'years').format('YYYY'),
          moment().subtract(2, 'years').format('YYYY'),
        ],
      },
      learningGoals: [],
      homeroomComments: [],
      absenceSummary: [
        {
          GREEN: '',
          RED: '',
          PERCENTAGE: 0,
        },
      ],
      isPlotClickEnable: false,
      series: [
        {
          type: 'boxPlot',
          data: [],
        },
      ],
      options: {
        chart: {
          type: 'boxPlot',
          zoom: {
            enabled: false,
          },
          events: {
            click: this.onClickonPlot,
          },
          height: 'auto',
          width: 350,
        },
        title: {
          text: '',
          align: 'left',
        },
        dataLabels: {
          enabled: false,
        },
        yaxis: {
          min: 0,
          max: 100,
          labels: {
            formatter: function (value) {
              return value + '%';
            },
          },
        },
        xaxis: {
          labels: {
            show: true,
            rotate: -45,
            rotateAlways: true,
            // style: {
            //   fontSize: [
            //     '50px'
            //   ],
            //   fontWeight: 400,
            // },
            hideOverlappingLabels: false,
            trim: false,
            maxHeight: 5000,
          },
        },
        tooltip: {
          enabled: true,
          y: {
            formatter: function (val) {
              return val + 'K';
            },
          },
        },
        plotOptions: {
          boxPlot: {
            colors: {
              upper: boxPlotColors.upper,
              lower: boxPlotColors.lower,
            },
            horizonal: true,
          },
        },
        colors: ['#C41425'],
        noData: {
          text: 'No records found',
          align: 'center',
          style: {
            fontSize: '14px',
          },
        },
      },

      showNotes: false,
      hideResultTooltip: true,
    };
  }

  componentDidMount() {
    // google analytic page view
    utilService.pageView();
    // save page visit logs to dynamodb
    let device = deviceDetect();
    let osName = utilService.getOsName(device);
    let browserName = utilService.getBrowserName(device);
    let pageLogsData = {
      ipstack_access_key: config.ipstack_access_key,
      pageId: 'parent-dashboard',
      title: 'Parent Dashboard',
      browserName: browserName,
      osName: osName,
      pageType: 'Parent Dashboard Page',
      visited_at: new Date(),
      users_userid: this.props.user.userUid,
      users_username: this.props.user.username,
      users_firstname: this.props.user.firstname,
      users_lastname: this.props.user.surname,
    };
    // save page logs
    this.props.savePageVisitLogs({
      token: this.props.token,
      data: pageLogsData,
    });
    if (this.props.carerStudents && this.props.carerStudents.length > 0) {
      this.setState({
        carerStudents: this.props.carerStudents,
      });
      // if (this.props.carerStudents.length > 0) {
      //   let student = this.props.carerStudents[0];
      //   // fetch plot courses of default studnet

      //   this.setState(
      //     {
      //       selectedStudent: student['STUDENT_USERNAME'],
      //     },
      //     function () {
      //       this.loadAbsenceSummary();
      //       this.loadPlotCourses();
      //       this.loadAcademicReports();
      //       this.loadLearningBehaviour();
      //     }
      //   );
      // }
    }
    if (this.props.user.type === 'student') {
      console.log(this.props.user, '123321');
      let objToSend = {
        target: {
          name: this.props.user.firstname,
          value: this.props.user.username,
        },
      };
      this.onChangeStudent(objToSend);
    }
    this.props.getCarerStudents({
      token: this.props.token,
      params:
        '?auth_username=' +
        this.props.user.username +
        '&student_group=Senior School Students',
    });
    // if (this.props.user && this.props.user.student_list) {
    //   let student = this.props.user.student_list[0];
    //   this.setState(
    //     {
    //       selectedStudent: student,
    //       absenceSummary: [
    //         {
    //           GREEN: '',
    //           RED: '',
    //           PERCENTAGE: '',
    //         },
    //       ],
    //     },
    //     function () {
    //       this.loadLearningBehaviour();
    //       this.loadPlotCourses();
    //       // this.loadLearningGoals();
    //       this.loadAcademicReports();
    //       this.loadAbsenceSummary();
    //       if (this.state.isPlotClickEnable) {
    //         this.loadPlotTasks();
    //       }
    //     }
    //   );
    //   this.onChangeStudent({ target: { name: '', value: student } });
    // }

    // this.props.getCarerStudents({
    //   token: this.props.token,
    //   params:
    //     '?auth_username=pmchugh' + '&student_group=Senior School Students',
    // });
  }

  onClickonPlot(event, chartContext, config) {
    if (!this.state.isPlotClickEnable) {
      this.setState({
        ...this.state,
        hideResultTooltip: false,
      });
      if (config['seriesIndex'] >= 0) {
        let plotCourseObj =
          this.state.series[config['seriesIndex']].data[
            config['dataPointIndex']
          ];

        let tempStr = plotCourseObj['x'].toString();
        var hasComma = tempStr.includes(',');

        if (hasComma) {
          plotCourseObj['x'] = tempStr.replaceAll(',', ' ');
        }
        this.setState(
          {
            clickedCourseId: plotCourseObj['x'],
            isPlotClickEnable: true,
          },
          function () {
            this.loadPlotTasks();
          }
        );
        // let params =
        //   '?username=' +
        //   this.state.selectedStudent +
        //   '&courseId=' +
        //   plotCourseObj['x'];
        // this.props.getPlotTask({
        //   token: this.props.token,
        //   params: params,
        // });
      }
    }
  }

  loadPlotTasks() {
    if (this.state.selectedStudent !== '') {
      let params =
        '?username=' +
        this.state.selectedStudent +
        '&courseId=' +
        this.state.clickedCourseId;
      this.props.getPlotTask({
        token: this.props.token,
        params: params,
      });
    }
  }

  onClickLearningBehaviourBox(e) {
    let series = [
      {
        data: [],
      },
    ];
    let options = {
      chart: {
        type: 'bar',
        height: 350,
      },
      plotOptions: {
        bar: {
          horizontal: false,
          columnWidth: '55%',
          endingShape: 'rounded',
        },
      },
      dataLabels: {
        enabled: false,
      },
      stroke: {
        show: true,
        width: 2,
        colors: ['transparent'],
      },
      xaxis: {
        categories: [],
        labels: {
          show: true,
          rotate: -45,
          rotateAlways: true,
          // style: {
          //   fontSize: [
          //     '50px'
          //   ],
          //   fontWeight: 400,
          // },
        },
      },
      yaxis: {
        // type: 'numeric',
        tickAmount: 4,
        min: 0,
        max: 100,
        title: {
          text: '',
        },
        labels: {
          formatter: function (value) {
            if (value === 25) {
              return 'Rarely';
            }
            if (value === 50) {
              return 'Sometimes';
            }
            if (value === 75) {
              return 'Usually';
            }

            if (value === 100) {
              return 'Consistently';
            }
            // return ''
          },
        },
      },
      fill: {
        opacity: 1,
      },
      tooltip: {
        y: {
          formatter: function (val) {
            return '' + val + ' perc';
          },
        },
      },
      noData: {
        text: 'No records found',
        align: 'center',
        style: {
          fontSize: '14px',
        },
      },
    };
    this.setState(
      {
        learningType: 'LEARNING_BY_BEHAVIOUR',
        showLearningDetails: true,
        showGoalReflectionsDetails: false,
        series: series,
        options: options,
        chartType: 'bar',
      },
      function () {
        this.loadLearningBehaviour();
      }
    );
  }

  /**
   * It is a react lifycycle method which is invoked immediately after updating occurs.
   * @param {*} prevProps Getting previous props
   * @param {*} prevState Getting previous state
   */
  componentDidUpdate(prevProps, prevState) {
    if (
      !this.state.selectedStudent &&
      !prevState.selectedStudent &&
      this.props.studentList.students !== prevProps.studentList.students
    ) {
      // console.log(this.props.studentList.students[0].username, "<<<<<<")
      this.setState({
        selectedStudent: this.props.studentList.students[0].username,
      });

      if (this.props.studentList.students) {
        this.setState(
          {
            selectedStudent: this.props.studentList.students[0].username,
            absenceSummary: [
              {
                GREEN: '',
                RED: '',
                PERCENTAGE: '',
              },
            ],
          },
          function () {
            this.loadLearningBehaviour();
            this.loadPlotCourses();
            // this.loadLearningGoals();
            this.loadAcademicReports();
            this.loadAbsenceSummary();
            if (this.state.isPlotClickEnable) {
              this.loadPlotTasks();
            }
          }
        );
        this.onChangeStudent({
          target: {
            name: '',
            value: this.props.studentList.students[0].username,
          },
        });
      }
    }
    if (!_.isEqual(prevProps.carerStudents, this.props.carerStudents)) {
      this.setState({
        carerStudents: this.props.carerStudents,
      });
      // if (this.props.carerStudents.length > 0) {
      //   let student = this.props.carerStudents[0];
      //   // fetch plot courses of default studnet

      //   this.setState(
      //     {
      //       selectedStudent: student['username'],
      //     },
      //     function () {
      //       this.loadAbsenceSummary();
      //       this.loadPlotCourses();
      //       this.loadAcademicReports();
      //       this.loadLearningBehaviour();
      //     }
      //   );
      // }
    }
    // if (
    //   prevProps.parentDashboard.sendNote !== this.props.parentDashboard.sendNote
    // ) {
    //   this.setState({
    //     showNotes: false,
    //   });
    // }
    if (!_.isEqual(prevProps.plotcourses, this.props.plotcourses)) {
      let plotData = [];
      let scatterData = [];
      if (this.props.plotcourses && this.props.plotcourses.length > 0) {
        this.props.plotcourses.forEach((item, index) => {
          let obj = {};
          let scatter_obj = {};

          obj['x'] = item['course'].match(/\b[\w']+(?:[^\w\n]+[\w']+){0,1}\b/g);
          scatter_obj['x'] = item['course'];
          obj['y'] = [
            Number(item['minimum']),
            Number(item['q1']),
            Number(item['median']),
            Number(item['q3']),
            Number(item['maximum']),
          ];
          scatter_obj['y'] = item['result'];
          plotData.push(obj);
          scatterData.push(scatter_obj);
        });
        let series = [
          {
            // name: 'Plot',
            type: 'boxPlot',
            data: plotData,
          },
          {
            name: 'Result',
            type: 'scatter',
            data: scatterData,
          },
        ];
        this.setState({
          ...this.state,
          series: series,
        });
      } else {
        this.setState({
          series: [
            {
              type: 'boxPlot',
              data: [],
            },
          ],
          options: {
            chart: {
              type: 'boxPlot',
              zoom: {
                enabled: false,
              },
              events: {
                click: this.onClickonPlot,
              },
              height: 'auto',
              width: 350,
            },
            title: {
              text: '',
              align: 'left',
            },
            dataLabels: {
              enabled: false,
            },
            yaxis: {
              min: 0,
              max: 100,
              labels: {
                formatter: function (value) {
                  return value + '%';
                },
              },
            },
            xaxis: {
              labels: {
                show: true,
                rotate: -45,
                rotateAlways: true,
                // style: {
                //   fontSize: [
                //     '50px'
                //   ],
                //   fontWeight: 400,
                // },
                hideOverlappingLabels: false,
                trim: false,
                maxHeight: 5000,
              },
            },
            tooltip: {
              enabled: true,
              y: {
                formatter: function (val) {
                  return val + 'K';
                },
              },
            },
            plotOptions: {
              boxPlot: {
                colors: {
                  upper: boxPlotColors.upper,
                  lower: boxPlotColors.lower,
                },
                horizonal: true,
              },
            },
            colors: ['#C41425'],
            noData: {
              text: 'No records found',
              align: 'center',
              style: {
                fontSize: '14px',
              },
            },
          },
        });
      }
    }
    if (!_.isEqual(prevProps.plottasks, this.props.plottasks)) {
      let plotData = [];
      let scatterData = [];
      let coursename = '';
      if (this.props.plottasks && this.props.plottasks.length > 0) {
        this.props.plottasks.forEach((item, index) => {
          let obj = {};
          let result = item['result'];
          let task = item['task'].split('(');
          let stream = task[0] + '(' + result + '%)';

          coursename = item['course'];
          let scatter_obj = {};
          obj['x'] = stream;
          scatter_obj['x'] = stream;
          obj['y'] = [
            Number(item['minimum']),
            Number(item['q1']),
            Number(item['mean']),
            Number(item['q3']),
            Number(item['maximum']),
          ];
          scatter_obj['y'] = item['result'];
          plotData.push(obj);
          scatterData.push(scatter_obj);
        });
        let series = [
          {
            // name: 'Plot',
            type: 'boxPlot',
            data: plotData,
          },
          {
            name: 'Result',
            type: 'scatter',
            data: scatterData,
          },
        ];
        this.setState({
          ...this.state,
          series: series,
          ...this.state.options,
          options: {
            ...this.state.options,
            title: {
              text: coursename,
              align: 'left',
            },
          },
          // isPlotClickEnable: false,
        });
      } else {
        this.setState({
          series: [
            {
              type: 'boxPlot',
              data: [],
            },
          ],
          options: {
            chart: {
              type: 'boxPlot',
              zoom: {
                enabled: false,
              },
              events: {
                click: this.onClickonPlot,
              },
              height: 'auto',
              width: 350,
            },
            title: {
              text: '',
              align: 'left',
            },
            dataLabels: {
              enabled: false,
            },
            yaxis: {
              min: 0,
              max: 100,
              labels: {
                formatter: function (value) {
                  return value + '%';
                },
              },
            },
            xaxis: {
              labels: {
                show: true,
                rotate: -45,
                rotateAlways: true,
                // style: {
                //   fontSize: [
                //     '50px'
                //   ],
                //   fontWeight: 400,
                // },
                hideOverlappingLabels: false,
                trim: false,
                maxHeight: 5000,
              },
            },
            tooltip: {
              enabled: true,
              y: {
                formatter: function (val) {
                  return val + 'K';
                },
              },
            },
            plotOptions: {
              boxPlot: {
                colors: {
                  upper: boxPlotColors.upper,
                  lower: boxPlotColors.lower,
                },
                horizonal: true,
              },
            },
            colors: ['#C41425'],
            noData: {
              text: 'No records found',
              align: 'center',
              style: {
                fontSize: '14px',
              },
            },
          },
        });
      }
    }

    if (!_.isEqual(prevProps.academicReports, this.props.academicReports)) {
      let academicReports = [];
      let defaultAcademicReport = '';
      if (this.props.academicReports && this.props.academicReports.length > 0) {
        academicReports = _.orderBy(
          this.props.academicReports,
          ['LAST_UPDATED'],
          ['desc']
        );
      }
      if (academicReports && academicReports.length > 0) {
        defaultAcademicReport = academicReports[0]['FILENAME'];
      }
      this.setState({
        academicReports: academicReports,
        selectedReport: defaultAcademicReport,
      });
    }

    if (!_.isEqual(prevProps.absenceSummary, this.props.absenceSummary)) {
      let absenceSummary = [
        {
          GREEN: '',
          RED: '',
          PERCENTAGE: 0,
        },
      ];
      if (this.props.absenceSummary && this.props.absenceSummary.length > 0) {
        absenceSummary = this.props.absenceSummary;
      }

      this.setState({
        absenceSummary: absenceSummary,
      });
    }

    if (!_.isEqual(prevProps.learningGoals, this.props.learningGoals)) {
      let learning_goals = [];
      if (this.props.learningGoals.length > 0) {
        learning_goals = this.props.learningGoals;
      }
      this.setState({
        learningGoals: learning_goals,
      });
    }

    if (!_.isEqual(prevProps.homeroomComments, this.props.homeroomComments)) {
      let homeroom_comments = [];
      if (this.props.homeroomComments.length > 0) {
        homeroom_comments = this.props.homeroomComments;
      }
      this.setState({
        homeroomComments: homeroom_comments,
      });
    }

    if (!_.isEqual(prevProps.learningBehaviour, this.props.learningBehaviour)) {
      if (this.state.learningType === 'LEARNING_BY_BEHAVIOUR') {
        let learning_behaviour = {};
        if (
          this.props.learningBehaviour &&
          this.props.learningBehaviour.length > 0
        ) {
          let groupByPeriod = [];
          groupByPeriod = _.groupBy(
            this.props.learningBehaviour,
            'report_period'
          );

          let series = [];
          let xaxisCategories = [];

          if (this.state.learningType === 'LEARNING_BY_BEHAVIOUR') {
            Object.keys(groupByPeriod).map((item, index) => {
              xaxisCategories.push(item);              
            });

            const behavioursSet = new Set();
            for (const termData of Object.values(groupByPeriod)) {
                for (const obj of termData) {
                    behavioursSet.add(obj.learning_behaviour);
                }
            }
            const behavioursOrder = [...behavioursSet];

            const result = {};
            for (const behaviour of behavioursOrder) {
                result[behaviour] = [];
            }
            for (const termData of Object.values(groupByPeriod)) {
              for (const obj of termData) {
                  const behaviour = obj.learning_behaviour;
                  const perc = obj.perc;
                  result[behaviour].push(perc);
              }
            }            
          for (const behaviour of behavioursOrder) {
            const existingDataLength = result[behaviour].length;
            const missingZerosLength = Object.keys(groupByPeriod).length - existingDataLength;
            const missingZeros = Array.from({ length: missingZerosLength }, () => 0);
            result[behaviour] = [...missingZeros, ...result[behaviour]];
          }

            const series = [];
            for (const behaviour of behavioursOrder) {
                const behaviourData = { name: behaviour, data: result[behaviour] };
                series.push(behaviourData);
            }
            this.setState({
              ...this.state,
              series: series,
              options: {
                ...this.state.options,
                xaxis: {
                  ...this.state.options.xaxis,
                  categories: xaxisCategories,
                },
              },
            });
          } else {
            Object.keys(groupByPeriod).map((item, periodIndex) => {
              xaxisCategories.push(item);
              let xcategoriesLen = xaxisCategories.length;
              groupByPeriod[item].forEach((data, index) => {
                let fieldName = 'learning_behaviour';
                if (this.state.learningType === 'LEARNING_BY_COURSE') {
                  fieldName = 'course';
                }
                let seriesObj = {
                  name: data[fieldName],
                  data: [],
                };
                xaxisCategories.forEach((xcat, index) => {
                  seriesObj['data'].push(null);
                });
                // seriesObj['data'].push(Number(data['PERC']), null, null);
                seriesObj['data'][periodIndex] = Number(data['perc']);
                series.push(seriesObj);
              });
            });

            this.setState({
              ...this.state,
              series: series,
              options: {
                ...this.state.options,
                xaxis: {
                  ...this.state.options.xaxis,
                  categories: xaxisCategories,
                },
              },
            });
          }

        } else {
          this.setState({
            series: [
              {
                data: [],
              },
            ],
            options: {
              chart: {
                type: 'bar',
                height: 350,
              },
              plotOptions: {
                bar: {
                  horizontal: false,
                  columnWidth: '55%',
                  endingShape: 'rounded',
                },
              },
              dataLabels: {
                enabled: false,
              },
              stroke: {
                show: true,
                width: 2,
                colors: ['transparent'],
              },
              xaxis: {
                categories: [],
                labels: {
                  show: true,
                  rotate: -45,
                  rotateAlways: true,
                  // style: {
                  //   fontSize: [
                  //     '50px'
                  //   ],
                  //   fontWeight: 400,
                  // },
                },
              },
              yaxis: {
                // type: 'numeric',
                tickAmount: 4,
                min: 0,
                max: 100,
                title: {
                  text: '',
                },
                labels: {
                  formatter: function (value) {
                    if (value === 25) {
                      return 'Rarely';
                    }
                    if (value === 50) {
                      return 'Sometimes';
                    }
                    if (value === 75) {
                      return 'Usually';
                    }

                    if (value === 100) {
                      return 'Consistently';
                    }
                    // return ''
                  },
                },
              },
              fill: {
                opacity: 1,
              },
              tooltip: {
                y: {
                  formatter: function (val) {
                    return '' + val + ' perc';
                  },
                },
              },
              noData: {
                text: 'No records found',
                align: 'center',
                style: {
                  fontSize: '14px',
                },
              },
            },
          });
        }
      } else {
        let learning_behaviour = {
          THIS_YEAR: null,
          TRENDING: '',
        };

        if (
          this.props.learningBehaviour &&
          this.props.learningBehaviour.length > 0
        ) {
          learning_behaviour = this.props.learningBehaviour[0];
        }

        this.setState({
          learningBehaviours: learning_behaviour,
        });
      }
    }

    if (
      this.state.learningType === 'LEARNING_BY_COURSE' &&
      !_.isEqual(prevProps.courseData, this.props.courseData)
    ) {
      if (this.props.courseData) {
        const series = this.props.courseData.series
          .map((c) => {
            return {
              name: c.title,
              data: [null, ...Object.values(c.data)],
            };
          })
          .sort((a, b) => a.name.localeCompare(b.name));
        console.log('ccc', series);

        this.setState({
          courseSeries: series,
        });
      }
    }
  }

  loadPlotCourses() {
    if (this.state.selectedStudent !== '') {
      this.setState({
        ...this.state,
        isPlotClickEnable: false,
        hideResultTooltip: true,
      });
      this.props.getPlotCourses({
        token: this.props.token,
        params: '?username=' + this.state.selectedStudent,
      });
    }
  }

  loadAcademicReports() {
    if (this.state.selectedStudent !== '') {
      this.props.getStudentAcademicReposts({
        token: this.props.token,
        params: '?username=' + this.state.selectedStudent,
      });
    }
  }

  loadAbsenceSummary() {
    if (this.state.selectedStudent !== '') {
      this.props.getStudentAbsenceSummary({
        token: this.props.token,
        params: '?username=' + this.state.selectedStudent,
      });
    }
  }

  loadLearningBehaviour() {
    if (this.state.selectedStudent !== '') {
      if (this.state.learningType === 'LEARNING_BY_COURSE') {
        this.props.getStudentLearningBehaviourByCourse({
          username: this.state.selectedStudent,
          token: this.props.token,
          // params:'?username=' + this.state.selectedStudent
        });
      }
      this.props.getStudentLearningBehaviour({
        token: this.props.token,
        params:
          '?username=' +
          this.state.selectedStudent +
          '&type=' +
          this.state.learningType,
      });
    }
  }

  loadLearningGoals() {
    if (this.state.selectedStudent !== '') {
      this.props.getStudentLearningGoals({
        token: this.props.token,
        params:
          '?username=' +
          this.state.selectedStudent +
          '&semester=' +
          this.state.goalsReflections['formFields']['semester'] +
          '&selected_year=' +
          this.state.goalsReflections['formFields']['selected_year'],
      });
    }
  }

  loadHomeroomComments() {
    if (this.state.selectedStudent !== '') {
      this.props.getHomeRoomComments({
        token: this.props.token,
        params:
          '?username=' +
          this.state.selectedStudent +
          '&semester=' +
          this.state.goalsReflections['formFields']['semester'] +
          '&selected_year=' +
          this.state.goalsReflections['formFields']['selected_year'],
      });
    }
  }

  onclickMoreButton(e) {
    e.preventDefault();
    let objToSend = {
      year: '2021 Year  7',
      username: this.state.selectedStudent,
    };
    this.props.history.push({ pathname: '/student-goals' });

    // load learning goals
    // this.loadLearningGoals();
    // this.loadHomeroomComments();

    // this.setState({
    //   showLearningDetails: false,
    //   showGoalReflectionsDetails: true,
    // });
  }

  onClickBack(e) {
    e.preventDefault();
    this.setState({
      ...this.state,
      hideResultTooltip: true,
    });
    if (this.state.showLearningDetails) {
      this.setState(
        {
          showLearningDetails: false,
          learningType: 'LEARNING_BEHAVIOUR_ANNUAL',
          series: [
            {
              type: 'boxPlot',
              data: [],
            },
          ],
          options: {
            chart: {
              type: 'boxPlot',
              zoom: {
                enabled: false,
              },
              events: {
                click: this.onClickonPlot,
              },
              height: 'auto',
              width: 350,
            },
            title: {
              text: '',
              align: 'left',
            },
            dataLabels: {
              enabled: false,
            },
            yaxis: {
              min: 0,
              max: 100,
              labels: {
                formatter: function (value) {
                  return value + '%';
                },
              },
            },
            xaxis: {
              labels: {
                show: true,
                rotate: -45,
                rotateAlways: true,
                // style: {
                //   fontSize: [
                //     '50px'
                //   ],
                //   fontWeight: 400,
                // },
                hideOverlappingLabels: false,
                trim: false,
                maxHeight: 5000,
              },
            },
            tooltip: {
              enabled: true,
              y: {
                formatter: function (val) {
                  return val + 'K';
                },
              },
            },
            plotOptions: {
              boxPlot: {
                colors: {
                  upper: boxPlotColors.upper,
                  lower: boxPlotColors.lower,
                },
                horizonal: true,
              },
            },
            colors: ['#C41425'],
            noData: {
              text: 'No records found',
              align: 'center',
              style: {
                fontSize: '14px',
              },
            },
          },
        },
        function () {
          this.loadLearningBehaviour();
          this.loadPlotCourses();
          // this.loadLearningGoals();
          this.loadAcademicReports();
          this.loadAbsenceSummary();
        }
      );
    }

    if (this.state.showGoalReflectionsDetails) {
      this.setState(
        {
          learningType: 'LEARNING_BEHAVIOUR_ANNUAL',
          showLearningDetails: false,
          showGoalReflectionsDetails: false,
          series: [
            {
              type: 'boxPlot',
              data: [],
            },
          ],
          options: {
            chart: {
              type: 'boxPlot',
              zoom: {
                enabled: false,
              },
              events: {
                click: this.onClickonPlot,
              },
              height: 'auto',
              width: 350,
            },
            title: {
              text: '',
              align: 'left',
            },
            dataLabels: {
              enabled: false,
            },
            yaxis: {
              min: 0,
              max: 100,
              labels: {
                formatter: function (value) {
                  return value + '%';
                },
              },
            },
            xaxis: {
              labels: {
                show: true,
                rotate: -45,
                rotateAlways: true,
                // style: {
                //   fontSize: [
                //     '50px'
                //   ],
                //   fontWeight: 400,
                // },
                hideOverlappingLabels: false,
                trim: false,
                maxHeight: 5000,
              },
            },
            tooltip: {
              enabled: true,
              y: {
                formatter: function (val) {
                  return val + 'K';
                },
              },
            },
            plotOptions: {
              boxPlot: {
                colors: {
                  upper: boxPlotColors.upper,
                  lower: boxPlotColors.lower,
                },
                horizonal: true,
              },
            },
            colors: ['#C41425'],
            noData: {
              text: 'No records found',
              align: 'center',
              style: {
                fontSize: '14px',
              },
            },
          },
        },
        function () {
          this.loadLearningBehaviour();
          this.loadPlotCourses();
          // this.loadLearningGoals();
          this.loadAcademicReports();
          this.loadAbsenceSummary();
        }
      );
    }

    if (this.state.isPlotClickEnable) {
      this.setState({
        isPlotClickEnable: false,
      });
    }

    this.loadPlotCourses();
    this.setState({
      // isPlotClickEnable: true,
      series: [
        {
          type: 'boxPlot',
          data: [],
        },
      ],
      options: {
        chart: {
          type: 'boxPlot',
          zoom: {
            enabled: false,
          },
          events: {
            click: this.onClickonPlot,
          },
          height: 'auto',
          width: 350,
        },
        title: {
          text: '',
          align: 'left',
        },
        dataLabels: {
          enabled: false,
        },
        yaxis: {
          min: 0,
          max: 100,
          labels: {
            formatter: function (value) {
              return value + '%';
            },
          },
        },
        xaxis: {
          labels: {
            show: true,
            rotate: -45,
            rotateAlways: true,
            // style: {
            //   fontSize: [
            //     '50px'
            //   ],
            //   fontWeight: 400,
            // },
            hideOverlappingLabels: false,
            trim: false,
            maxHeight: 5000,
          },
        },
        tooltip: {
          enabled: true,
          y: {
            formatter: function (val) {
              return val + 'K';
            },
          },
        },
        plotOptions: {
          boxPlot: {
            colors: {
              upper: boxPlotColors.upper,
              lower: boxPlotColors.lower,
            },
            horizonal: true,
          },
        },
        colors: ['#C41425'],
        noData: {
          text: 'No records found',
          align: 'center',
          style: {
            fontSize: '14px',
          },
        },
      },
    });
  }

  onChangeStudent(e) {
    const { name, value } = e.target;
    if (
      this.state.showLearningDetails &&
      !this.state.showGoalReflectionsDetails &&
      this.state.learningType !== 'LEARNING_BEHAVIOUR_ANNUAL'
    ) {
      console.log('inside if');
      this.setState(
        {
          selectedStudent: value,
        },
        function () {
          this.loadLearningBehaviour();
        }
      );
    } else if (this.state.showGoalReflectionsDetails) {
      console.log('inside else if');
      this.setState(
        {
          selectedStudent: value,
        },
        function () {
          this.loadLearningGoals();
          this.loadHomeroomComments();
        }
      );
    } else {
      console.log('inside else');
      this.setState(
        {
          selectedStudent: value,
          absenceSummary: [
            {
              GREEN: '',
              RED: '',
              PERCENTAGE: '',
            },
          ],
          hideResultTooltip: true,
        },
        function () {
          this.loadLearningBehaviour();
          this.loadPlotCourses();
          // this.loadLearningGoals();
          this.loadAcademicReports();
          this.loadAbsenceSummary();
          if (this.state.isPlotClickEnable) {
            this.loadPlotTasks();
          }
        }
      );
    }
  }

  onChangeInput(e) {
    const { name, value } = e.target;
    let fields = this.state.goalsReflections.formFields;
    fields[name] = value;
    this.setState(
      {
        fields,
      },
      function () {
        this.loadLearningGoals();
        this.loadHomeroomComments();
      }
    );
  }

  onChangeAcademicReport(e) {
    const { value } = e.target;
    let obj = JSON.parse(value);
    if (obj.FILE_PATH === 'custom') {
      this.setState({
        selectedObj: obj,
        selectedReport: obj.FILENAME,
        file_id: obj.FILE_ID,
        is_dwd: true,
      });
    } else {
      this.setState({
        selectedObj: obj,
        selectedReport: obj.FILENAME,
        is_dwd: false,
      });
    }
  }

  onChangeLearningType(e) {
    // alert("changes")
    const { name, value } = e.target;
    let series = [
      {
        data: [],
      },
    ];
    let barChartOptions = {};
    let options = {};
    let chartType = '';
    if (value === 'LEARNING_BY_BEHAVIOUR') {
      chartType = 'bar';
      options = {
        chart: {
          type: 'bar',
          height: 350,
        },
        plotOptions: {
          bar: {
            horizontal: false,
            columnWidth: '55%',
            endingShape: 'rounded',
          },
        },
        dataLabels: {
          enabled: false,
        },
        stroke: {
          show: true,
          width: 2,
          colors: ['transparent'],
        },
        legend: {
          show: true,
          position: 'bottom',
        },
        xaxis: {
          categories: [],
          show: true,
          rotate: -45,
          rotateAlways: true,
          style: {
            fontSize: ['50px'],
            fontWeight: 400,
          },
        },
        yaxis: {
          // type: 'numeric',
          tickAmount: 4,
          min: 0,
          max: 100,
          title: {
            text: '',
          },
          labels: {
            formatter: function (value) {
              if (value === 25) {
                return 'Rarely';
              }
              if (value === 50) {
                return 'Sometimes';
              }
              if (value === 75) {
                return 'Usually';
              }

              if (value === 100) {
                return 'Consistently';
              }
              // return ''
            },
          },
        },
        fill: {
          opacity: 1,
        },
        tooltip: {
          y: {
            formatter: function (val) {
              return '' + val + ' perc';
            },
          },
        },
        noData: {
          text: 'No records found',
          align: 'center',
          style: {
            fontSize: '14px',
          },
        },
      };
    } else {
      series = [
        {
          data: [],
        },
      ];
      chartType = 'line';
      options = {
        colors: [
          '#CEDD37',
          '#3E9A8B',
          '#458FCD',
          '#00009C',
          '#45A54A',
          '#4256A6',
          '#00628b',
          '#F07F21',
          '#E73D97',
          '#DF205A',
          '#8AC349',
          '#ED2A26',
        ],
        noData: {
          text: 'No records found',
          align: 'center',
          verticalAlign: 'middle',
        },
        chart: {
          height: 450,
          type: 'line',
          zoom: {
            enabled: false,
          },
          animations: {
            enabled: false,
          },
        },
        dataLabels: {
          enabled: false,
        },
        stroke: {
          width: 2,
          curve: 'straight',
        },
        labels: [
          '',
          'LAST YEAR TERM 1',
          'LAST YEAR TERM 2',
          'LAST YEAR TERM 3',
          'LAST YEAR TERM 4',
          'THIS YEAR TERM 1',
          'THIS YEAR TERM 2',
          'THIS YEAR TERM 3',
          'THIS YEAR TERM 4',
        ],
        title: {
          text: '',
          align: 'left',
        },

        yaxis: {
          max: 110,
          // logBase: 20,
          tickAmount: 11,
          min: 0,
          labels: {
            formatter: function (value) {
              if (value && (value !== null || value !== 'null')) {
                return value + '%';
              } else {
                return undefined;
              }
            },
          },
        },
        xaxis: {
          labels: {
            show: true,
            rotate: -45,
            rotateAlways: true,
            style: {
              fontSize: [],
              fontWeight: 400,
            },
            hideOverlappingLabels: false,
            trim: false,
            maxHeight: 5000,
          },
        },
      };

      barChartOptions = {
        colors: [
          '#CEDD37',
          '#3E9A8B',
          '#458FCD',
          '#00009C',
          '#45A54A',
          '#4256A6',
          '#00628b',
          '#F07F21',
          '#E73D97',
          '#DF205A',
          '#8AC349',
          '#ED2A26',
        ],
        noData: {
          text: 'No records found',
          align: 'center',
          verticalAlign: 'middle',
        },
        chart: {
          height: 450,
          type: 'bar',
          zoom: {
            enabled: false,
          },
          animations: {
            enabled: false,
          },
          // stacked: true,
        },
        plotOptions: {
          bar: {
            horizontal: false,
          },
        },
        dataLabels: {
          enabled: false,
        },
        stroke: {
          curve: 'straight',
          width: 2,
        },
        labels: [
          '',
          'LAST YEAR TERM 1',
          'LAST YEAR TERM 2',
          'LAST YEAR TERM 3',
          'LAST YEAR TERM 4',
          'THIS YEAR TERM 1',
          'THIS YEAR TERM 2',
          'THIS YEAR TERM 3',
          'THIS YEAR TERM 4',
        ],
        title: {
          text: '',
          align: 'left',
        },

        yaxis: {
          max: 100,
          // logBase: 20,
          // tickAmount:11,
          min: 0,
          labels: {
            formatter: function (value) {
              if (value && (value !== null || value !== 'null')) {
                return value + '%';
              } else {
                return undefined;
              }
            },
          },
        },
        xaxis: {
          labels: {
            show: true,
            rotate: -45,
            rotateAlways: true,
            style: {
              fontSize: [],
              fontWeight: 400,
            },
            hideOverlappingLabels: false,
            trim: false,
            maxHeight: 5000,
          },
        },
      };
    }
    this.setState(
      {
        learningType: value,
        series: series,
        options: options,
        chartType: chartType,
        courseOptions: options,
        courseSeries: series,
        barChartOptions: barChartOptions,
      },
      function () {
        this.loadLearningBehaviour();
      }
    );
  }

  onDownloadReport(e) {
    e.preventDefault();
    if (this.state.selectedReport && !this.state.is_dwd) {
      let formData = new FormData();

      formData.append('SECRETKEY', 'MAGIC_MONKEY_MAN');
      formData.append('filename', this.state.selectedReport);

      this.setState({
        downloading_pdf: true,
      });

      // call edumate api to download academic report pdf

      fetch(config.url.download_annual_report, {
        method: 'POST',
        body: formData,
      })
        .then((response) => response.blob())
        .then((blob) => {
          this.setState({
            downloading_pdf: false,
          });
          const url = window.URL.createObjectURL(new Blob([blob]));
          const anchor = document.createElement('a');
          anchor.setAttribute('href', url);
          anchor.setAttribute('target', '_blank');
          anchor.setAttribute('download', this.state.selectedReport + '.pdf');
          anchor.click();
          anchor.remove();
        })
        .catch((error) => {
          console.error('Error...', error);
        });
    } else if (this.state.is_dwd && this.state.file_id) {
      let formData = new FormData();

      formData.append('SECRETKEY', 'MAGIC_MONKEY_MAN');
      formData.append('filename', this.state.selectedReport);

      this.setState({
        downloading_pdf: true,
      });

      // call edumate api to download academic report pdf

      fetch(this.state.file_id, {
        method: 'GET',
      })
        .then((response) => response.blob())
        .then((blob) => {
          this.setState({
            downloading_pdf: false,
          });
          const url = window.URL.createObjectURL(new Blob([blob]));
          const anchor = document.createElement('a');
          anchor.setAttribute('href', this.state.file_id);
          anchor.setAttribute('target', '_blank');
          anchor.setAttribute('download', this.state.selectedReport + '.pdf');
          anchor.click();
          anchor.remove();
        })
        .catch((error) => {
          console.error('Error...', error);
        });
    }
  }

  handleNotes(flag, data) {
    this.setState({
      showNotes: flag,
      studentInfo: data,
    });
  }

  render() {
    const {
      carerStudents,
      studentList,
      plotcourses,
      plottasks,
      academicReports,
      absenceSummary,
      learningBehaviour,
      learningGoals,
      homeroomComments,
    } = this.props;
    const academicReport = academicReports
      ? academicReports.sort((a, b) => a.FILENAME.localeCompare(b.FILENAME))
      : [];
    const attendanceRate = this.state.absenceSummary[0]['percentage'];
    const trendingImages = {
      Up: '/assets/img/up-trend.png',
      Down: '/assets/img/down-trend.png',
      Maintaining: '/assets/img/stable-trend.png',
    };

    let options = [];
    let optionsList = [];
    if (carerStudents && carerStudents.length > 0) {
      carerStudents.forEach((item, index) => {
        let year = '';
        if ('orgunit' in item) {
          let orgunits = item['orgunit'].split('/');
          year = _.find(orgunits, function (year) {
            if (year.includes('Year')) {
              return year;
            }
          });
        }
        optionsList.push({
          name: item['firstname'] + ' ' + item['surname'] + ' ' + year,
          username: item['username'],
        });
        options.push(
          <option key={item['userUid']} value={item['username']}>
            {item['firstname'] + ' ' + item['surname'] + ' ' + year}
          </option>
        );
      });
    }
    // console.log('sad', this.state.learningType === 'LEARNING_BY_COURSE');
    let component =
      this.state.learningType === 'LEARNING_BY_COURSE' ? (
        <>
          <Chart
            options={this.state.courseOptions}
            series={this.state.courseSeries}
            type={this.state.chartType}
            height={450}
            width="100%"
          />
          <Chart
            options={this.state.barChartOptions}
            series={this.state.courseSeries}
            type={this.state.chartType}
            height={450}
            width="100%"
          />
        </>
      ) : (
        <Chart
          options={this.state.options}
          series={this.state.series}
          type={this.state.chartType}
          height={400}
        />
      );
    return (
      <>
        {this.state.showNotes ? (
          <NotesPopup
            handleNotes={this.handleNotes}
            showNotes={this.state.showNotes}
            studentInfo={this.state.studentInfo}
          />
        ) : (
          ''
        )}
        <BackStrip
          nav="/"
          isFilter="false"
          heading={{ text: 'Parent Dashboard', icon: 'fa fa-check-square-o' }}
        />
        <main className="connection">
          {this.props.parentDashboardActionLoading === true && (
            <utilService.GridSweetLoader
              loading={this.props.parentDashboardActionLoading}
            />
          )}
          <Container fluid className="md-container-default-space">
            <Row noGutters className="justify-content-center">
              <StudentTable
                changeStudent={this.onChangeStudent}
                handleNotes={this.handleNotes}
                absenceSummary={this.props.absenceSummary}
              />
              <Col xl={7} lg={8} xs={12}>
                <div className="d-flex align-items-start">
                  <div className="flex-shrink-0">
                    <button
                      type="button"
                      className="btn btn-dark btn-icon h1 rounded-circle mr-3"
                      onClick={this.onClickBack.bind(this)}
                    >
                      <i className="fa fa-arrow-left fa-w-16" />
                    </button>
                  </div>
                  <div className="flex-grow-1">
                    {this.props.user.type !== 'student' &&
                    studentList.students &&
                    studentList.students.length > 1 ? (
                      <select
                        className="mb-3 form-control w-100"
                        onChange={this.onChangeStudent}
                        value={this.state.selectedStudent || ''}
                      >
                        {/* <option value="" data-list={studentList.students && studentList.students.length ? 1 : 0}>Select Student</option> */}
                        {studentList.students &&
                          studentList.students.map((item) => (
                            <option key={item.studentUid} value={item.username}>
                              {item.student}
                            </option>
                          ))}
                      </select>
                    ) : (
                      studentList.students && (
                        <input
                          type="text"
                          className="form-control h-auto lh-1 py-3 w-100"
                          value={
                            studentList.students.length > 0 &&
                            studentList.students[0].student
                          }
                          disabled={true}
                        />
                      )
                    )}

                    {this.state.showLearningDetails && (
                      <select
                        className="mb-3 form-control"
                        onChange={this.onChangeLearningType}
                        value={this.state.learningType}
                      >
                        <option value="LEARNING_BY_BEHAVIOUR">
                          By Behaviour
                        </option>
                        <option value="LEARNING_BY_COURSE"> By Course</option>
                      </select>
                    )}
                  </div>
                </div>

                {!this.state.showGoalReflectionsDetails &&
                  this.state.learningType === 'LEARNING_BEHAVIOUR_ANNUAL' && (
                    <div>
                      <Row className="px-md-3 px-4">
                        <Col
                          sm={4}
                          xs={6}
                          className="text-center px-1 px-md-2 mb-3 cursor-pointer"
                          role="button"
                          onClick={this.onClickLearningBehaviourBox}
                        >
                          <div className="border h-100 px-0 py-3 px-md-3 position-relative">
                            <span className={cx('mb-4', ParentStyle.textFit)}>
                              Learning Behaviours
                            </span>
                            {this.state.learningBehaviours['this_year'] ? (
                              <span
                                className={cx(
                                  ParentStyle.bgBoxFill,
                                  ParentStyle.fillPear
                                )}
                                style={{
                                  height: `${
                                    this.state.learningBehaviours[
                                      'this_year'
                                    ] || 100
                                  }%`,
                                }}
                              />
                            ) : (
                              <span className={ParentStyle.middleText}>
                                {this.state.learningBehaviours['this_year'] ===
                                  null && 'No data yet!'}
                              </span>
                            )}
                            {this.state.learningBehaviours['trending'] in
                              trendingImages && (
                              <span className={ParentStyle.middleText}>
                                <img
                                  alt={`Trending ${this.state.learningBehaviours['trending']}`}
                                  src={
                                    trendingImages[
                                      this.state.learningBehaviours['trending']
                                    ]
                                  }
                                  className="img-fluid mt-5"
                                />
                              </span>
                            )}
                            <div className={ParentStyle.behaviourScale}>
                              {this.behaviourScales.map((scale, index) => (
                                <small
                                  key={`scale${index}`}
                                  style={{ top: `${scale.positionTop}%` }}
                                  className={cx(
                                    'text-muted',
                                    ParentStyle.scaleText
                                  )}
                                >
                                  {scale.text}
                                </small>
                              ))}
                            </div>
                            <span
                              className={cx(
                                ParentStyle.boxMoreLink,
                                'btn-primary rounded-circle p-sm-1 p-0 font-weight-500 lh-0 d-flex align-items-center'
                              )}
                            >
                              more
                            </span>
                          </div>
                        </Col>

                        <Col
                          sm={4}
                          xs={6}
                          className="text-center px-1 px-md-2 mb-3"
                        >
                          <Link
                            to="/absences"
                            target="_blank"
                            rel="noopener noreferrer"
                            role="button"
                          >
                            <div className="border h-100 py-3 position-relative">
                              <span
                                className={cx('d-block', ParentStyle.textFit)}
                              >
                                Verified Absences
                              </span>
                              <span className="display-4 text-dark-green">
                                {this.state.absenceSummary[0]['green']}
                              </span>
                              <span
                                className={cx('d-block', ParentStyle.textFit)}
                              >
                                Unverified
                              </span>
                              <span className="display-4 text-primary">
                                {this.state.absenceSummary[0]['red']}
                              </span>
                              <span
                                className={cx(
                                  ParentStyle.boxMoreLink,
                                  'btn-primary rounded-circle p-sm-1 p-0 font-weight-500 lh-0 d-flex align-items-center'
                                )}
                              >
                                more
                              </span>
                            </div>
                          </Link>
                        </Col>
                        <Col
                          sm={4}
                          xs={6}
                          className="text-center px-1 px-md-2 mb-3"
                        >
                          <div className="border h-100 pb-5 pt-3">
                            <span
                              className={cx(
                                'd-block pb-4',
                                ParentStyle.textFit
                              )}
                            >
                              Attendance Rate
                            </span>
                            <span
                              className={cx('display-4', {
                                'text-green': attendanceRate >= 60,
                                'text-orange':
                                  attendanceRate >= 40 && attendanceRate < 60,
                                'text-primary': attendanceRate < 40,
                              })}
                            >
                              {attendanceRate}%
                            </span>
                          </div>
                        </Col>
                        { /*
                        <Col
                          sm={3}
                          xs={6}
                          role="button"
                          className="d-flex align-items-center justify-content-center px-1 px-md-2 mb-3 cursor-pointer"
                          onClick={this.onclickMoreButton.bind(this)}
                        >
                          <img
                            className="img-fluid"
                            alt="Add Goals and Comment"
                            src="/assets/img/goals-n-comment.png"
                          />
                          <span
                            className={cx(
                              ParentStyle.boxMoreLink,
                              'btn-primary rounded-circle p-sm-1 p-0 font-weight-500 lh-0 d-flex align-items-center'
                            )}
                          >
                            more
                          </span>
                        </Col>
                        */}
                      </Row>
                      <div className="my-4 d-flex align-items-stretch flex-shrink-0">
                        <select
                          className="form-control flex-fill h-auto mr-3"
                          onChange={this.onChangeAcademicReport}
                          value={JSON.stringify(this.state.selectedObj) || ''}
                        >
                          {academicReport.map((item, index) => (
                            <option key={index} value={JSON.stringify(item)}>
                              {item.FILENAME}
                            </option>
                          ))}
                        </select>
                        <button
                          type="button"
                          className="btn btn-icon btn-pear p-0 flex-shrink-0 d-flex align-items-center mr-3"
                          onClick={this.onDownloadReport.bind(this)}
                          // disabled={this.props.pdfActionLoading}
                          title="Download Report"
                        >
                          <span className="pl-3 d-none d-sm-inline-block">
                            Download Report
                          </span>
                          {/* <i className="fa fa-file-pdf-o flex-shrink-0 h3 lh-1 md-display-6 p-3" /> */}
                          <i
                            className={cx(
                              'fa fa-file-pdf-o flex-shrink-0 h3 lh-1 md-display-6 p-3',
                              {
                                'd-none': this.state.downloading_pdf,
                              }
                            )}
                          />
                          <span
                            className={cx('p-3', {
                              'd-none': !this.state.downloading_pdf,
                            })}
                          >
                            <utilService.BorderSpinner
                              loading={this.state.downloading_pdf}
                              color="pear"
                              size={1.5}
                            />
                          </span>
                        </button>
                        {/* <button
                  type="button"
                  className="btn btn-pear flex-shrink-0"
                  onClick={this.onDownloadReport.bind(this)}
                >
                  <span></span>
                </button> */}
                      </div>
                      <div>
                        <div
                          id="chart"
                          className={`${
                            this.state.hideResultTooltip
                              ? 'hide-boxplot-tooltip'
                              : ''
                          }`}
                        >
                          <Chart
                            options={this.state.options}
                            series={this.state.series}
                            type="boxPlot"
                            height={350}
                          />
                        </div>
                      </div>
                    </div>
                  )}
                {this.state.showLearningDetails &&
                  !this.state.showGoalReflectionsDetails &&
                  this.state.learningType !== 'LEARNING_BEHAVIOUR_ANNUAL' && (
                    <div>
                      <div id="chart">{component}</div>
                    </div>
                  )}
                {this.state.showGoalReflectionsDetails && (
                  <LearningGoals
                    goalsReflections={this.state.goalsReflections}
                    onChangeInput={this.onChangeInput.bind(this)}
                    learningGoals={this.state.learningGoals}
                    homeRoomComments={this.state.homeroomComments}
                  />
                )}
              </Col>
            </Row>
          </Container>
        </main>
      </>
    );
  }
}

/**
 * It is called every time the store state changes.
 * It receives the entire store state, and should return an object of data this component needs.
 * @param {*} state : Getting updated state object from reducer
 * @param {*} props : Getting props of this component
 */
function mapStateToProps(state) {
  let data = Object.values(state.parentDashboard.learning_behaviour.byId);
  const learningBehaviourData = []
    .concat(data)
    .sort((a, b) => a.report_period.localeCompare(b.report_period))
    .map((item, i) => item);

  return {
    parentDashboardActionLoading: state.parentDashboard.actionsloading,
    token: state.user.cognito_data.token,
    user: state.user.user,
    userGroups: state.user.user.group_list,
    carerStudents: Object.values(state.parentDashboard.carerStudents.byId),
    studentList: { ...state.parentDashboard.studentList.studentListData },
    plotcourses: Object.values(state.parentDashboard.plotcourses.byId),
    plottasks: Object.values(state.parentDashboard.plottasks.byId),
    academicReports: Object.values(state.parentDashboard.academic_reports.byId),
    absenceSummary: Object.values(state.parentDashboard.absence_summary.byId),
    learningBehaviour: learningBehaviourData,
    courseData: state.parentDashboard.learning_behaviour.courseData,
    learningGoals: Object.values(state.parentDashboard.learning_goals.byId),
    homeroomComments: Object.values(
      state.parentDashboard.homeroom_comments.byId
    ),
    parentDashboard: state.parentDashboard,
  };
}

/**
 * connect() function connects a react component to a redux store.
 */
export default connect(mapStateToProps, (dispatch) =>
  bindActionCreators(Object.assign({}, absencesActions, adminActions), dispatch)
)(ParentDashboard);
